import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { isMobile } from "react-device-detect";
import { Button } from "@mui/material";
import PropTypes from "prop-types";


export default function SeguridadItem(props) {
  const theme = useTheme();
  const { serv } = props;

  return (
    <Box
      id={serv.alt}
      sx={{
        display: "flex",
        border: "solid 1px  rgba(207, 207, 207, 1)",
        borderRadius: "4px",
        boxShadow: "0 15px 35px  #6699ff",
        maxWidth: "96%",
        margin: "0 auto",
        marginBottom: ".6rem",
        alignItems: "center",
        padding: ".3rem",
        flexDirection: "column",
          textAlign: "start",
      }}
    >
    
        <div
          style={{
            width: "100%",
            height: "15rem",
            backgroundImage: `url(${serv.imagen})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
            }}
          ></div>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection:'column',
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{ textTransform: "uppercase", color: "#fafafa" }}
              component="div"
              variant="h5"
            >
              {serv.nombre}
            </Typography>
           <Button href={"/bomberos#contacto"} sx={{marginTop:'1rem'}} variant='contained' color='success'>Recibir asesoramiento</Button> 
          </div>
        </div>

        
        <div style={{
            width: "96%",
            padding: isMobile ? ".6rem" : "1rem",           
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}>
          {serv.descripcion.map((desc) => {
            return (
              <Typography key={desc.index} component="div" variant="body-1" mb='1.5rem'>
                {desc}
              </Typography>
            );
          })}
        </div>      
    </Box>
  );
  
  // eslint-disable-next-line no-unreachable
  SeguridadItem.propTypes = {
    serv:PropTypes.shape({
    imagen: PropTypes.string,
    descripcion: PropTypes.shape({
   
  }),
  }),
  };
}
